module.exports = __webpack_public_path__ + "d293262a.png";